export default class Selector extends React.PureComponent

  constructor: (props) ->
    super(props)

    @selectRef = React.createRef()
    @onChange  = @onChange.bind(this)

  onChange: (e) ->
    @props.onChange(e)
    @selectRef.current.blur() # unfocus selector

  # A select is always as wide as its widest option (even if not current),
  # so we need to use a fake button for the pleasant visual effect of
  # having the select take only the width of its currently selected option
  render: ->
    <div className="select-container">
      { @renderFakeButton() }
      { @renderHiddenSelect() }
    </div>

  renderFakeButton: ->
    <span className="select-button">
      <span>{ @props.value }</span>
      <small><i className="fas fa-angle-down ms-2" /></small>
    </span>

  renderHiddenSelect: ->
    <select className="hidden-select"
            ref={@selectRef}
            id={@props.id}
            value={@props.value}
            onChange={@onChange} >
      { @renderOptions() }
    </select>

  renderOptions: ->
    @props.options.map((option) =>
      <option value={option[0]} key={option[0]}>
        {@renderOption(option)}
      </option>
    )

  renderOption: (option) ->
    if @props.optionFormatter
      @props.optionFormatter(option)
    else
      option[1]


